import { DatePicker, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import moment from "moment";

const wind_conditions = [
  "0 Beaufort - Calm",
  "1 Beaufort - Light Air",
  "2 Beaufort - Light Breeze",
  "3 Beaufort - Gentle Breeze",
  "4 Beaufort - Moderate Breeze",
  "5 Beaufort - Fresh Breeze",
  "6 Beaufort - Strong Breeze",
  "7 Beaufort - Near Gale",
  "8 Beaufort - Gale",
  "9 Beaufort - Strong Gale",
  "10 Beaufort - Storm",
  "11 Beaufort - Violent Storm",
  "12 Beaufort - Hurricane",
];
const visibility_Data = [
  "0 - Less than 50 m (less than 55 yd.)",
  "1 - 50 m but less than 200 m",
  "2 - 200 m but less than 500 m",
  "3 - 500 m but less than 1 km",
  "4 - 1 km but less than 2 km",
  "5 - 2 km but less than 4 km (1 nm but less than 2 nm)",
  "6 - 4 km but less than 10 km (2 nm but less than 5 nm)",
  "7 - 10 km but less than 20 km (5 nm but less than 11 nm)",
  "8 - 20 km but less than 50 km (11 nm but less than 27 nm)",
  "9 - 50 km or greater (27 nm or greater)",
];

function CompanyViewDeckLog() {
  const { id } = useParams();
  const [sea_condition, set_sea_condition] = useState("");
  const [wind_condition, set_wind_condition] = useState([]);
  const [swell, set_swell] = useState("");
  const [position_in_latitude, set_position_in_latitude] = useState("");
  const [position_in_longitude, set_position_in_longitude] = useState("");
  const [speed, set_speed] = useState("");
  const [speed_on_ground, set_speed_on_ground] = useState("");
  const [distance_covered, set_distance_covered] = useState("");
  const [voyage_qty_of_cargo, set_voyage_qty_of_cargo] = useState("");
  const [qty_of_ballast, set_qty_of_ballast] = useState("");
  const [port_from, set_port_from] = useState("");
  const [port_to, set_port_to] = useState("");
  const [instructed_speed, set_instructed_speed] = useState("");
  const [loaded_ballast, set_loaded_ballast] = useState("");
  const [draft, set_draft] = useState("");
  const [free_Text, set_Free_Text] = useState("");
  const [course_heading, set_course_heading] = useState("");
  const [distance_to_go, set_Distance_To_Go] = useState("");
  const [hours_Underway, set_Hours_Underway] = useState("");
  const [hsfo_consumption, set_hsfo_consumption] = useState("");
  const [vlsfo_consumption, set_vlsfo_consumption] = useState("");
  const [lsmgo_consumption, set_lsmgo_consumption] = useState("");
  const [other_consumption, set_other_consumption] = useState("");
  const [logDate, set_LogDate] = useState(null);
  const [vessel_status, set_vessel_status] = useState("");
  const [lo_consumption, set_lo_consumption] = useState("");
  const [fw_consumption, set_fw_consumption] = useState("");
  const [swell_direction, set_swell_direction] = useState("");
  const [visibility, set_visibility] = useState("");

  const VIEW_DECK_LOGBOOK_APIS = () => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("deck_log_id", atob(id));
    post(ApiURL.view_deck_log_com, FORM_DATA).then((res) => {
      if (res?.status == true) {
        const deck_Data = res?.deck_log;
        set_sea_condition(deck_Data?.sea_condition);
        set_wind_condition(deck_Data?.wind_condition);
        set_swell(deck_Data?.swell);
        set_position_in_latitude(deck_Data?.latitude);
        set_position_in_longitude(deck_Data?.longitude);
        set_speed(deck_Data?.speed_gps);
        set_speed_on_ground(deck_Data?.speed_through_water);
        set_distance_covered(deck_Data?.distance_covered);
        set_voyage_qty_of_cargo(deck_Data?.qty_of_cargo);
        set_qty_of_ballast(deck_Data?.qty_of_ballast);
        set_port_from(deck_Data?.port_from);
        set_port_to(deck_Data?.port_to);
        set_instructed_speed(deck_Data?.instructed_speed);
        set_loaded_ballast(deck_Data?.voyage_type);
        set_draft(deck_Data?.draft);
        set_Free_Text(deck_Data?.deck_comment);
        set_course_heading(deck_Data?.course);
        set_Distance_To_Go(deck_Data?.distance_to_go);
        set_Hours_Underway(deck_Data?.hours_underway);
        set_vlsfo_consumption(deck_Data?.vlsfo_consumption);
        set_lsmgo_consumption(deck_Data?.lsmgo_consumption);
        set_hsfo_consumption(deck_Data?.hsfo_consumption);
        set_other_consumption(deck_Data?.other_consumption);
        set_LogDate(deck_Data?.log_date_time);
        set_vessel_status(deck_Data?.vessel_status);
        set_lo_consumption(deck_Data?.lube_orb);
        set_fw_consumption(deck_Data?.fw_rob);
        set_swell_direction(deck_Data?.swell_direction);
        set_visibility(deck_Data?.visibility);
      } else {
        const errors = res?.errors || {};
      }
    });
  };

  useEffect(() => {
    VIEW_DECK_LOGBOOK_APIS();
  }, []);

  return (
    <>
      <div className="white-container">
        <br />
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Date & Time</label>
              <DatePicker
                disabled
                showTime
                format="YYYY-MM-DD HH:mm:ss"
                placeholder="Select Date & Time"
                value={logDate ? moment(logDate, "YYYY-MM-DD HH:mm:ss") : null}
                
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>vessel status</label>
              <Select
                disabled
                value={vessel_status}
                placeholder=" -- Select of  vessel status  -- "
                style={{ width: "100%" }}
                onChange={(value) => set_vessel_status(value)}
              >
                <Select.Option value="At Sea">At Sea</Select.Option>
                <Select.Option value="At Anchor">At Anchor</Select.Option>
                <Select.Option value="At Port">At Port</Select.Option>
              </Select>
            </div>
          </div>
        </div>
        <h3>Weather Details </h3>
        <div className="row">
          {/* Sea Condition */}
          <div className="col-6">
            <div className="input-box">
              <label>Sea Condition</label>
              <Input
                disabled
                value={sea_condition}
                placeholder="Sea Condition"
                onChange={(e) => set_sea_condition(e.target.value)}
              />
            </div>
          </div>
          {/* Wind Condition */}
          <div className="col-6">
            <div className="input-box">
              <label>Wind Force</label>
              <Select
                disabled
                placeholder="--select of Wind Force --"
                style={{ width: "100%" }}
                value={wind_condition}
                onChange={(value) => set_wind_condition(value)}
              >
                {wind_conditions?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Swell */}
          <div className="col-6">
            <div className="input-box">
              <label>Swell Height (In meters)</label>
              <Input
                disabled
                value={swell}
                placeholder="Swell Height"
                onChange={(e) => set_swell(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Swell Direction</label>
              <Input
                disabled
                value={swell_direction}
                placeholder="Swell Direction"
                onChange={(e) => set_swell_direction(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Visibility</label>
              <Select
                disabled
                placeholder="--select of Visibility --"
                style={{ width: "100%" }}
                value={visibility}
                onChange={(value) => set_visibility(value)}
              >
                {visibility_Data?.map((name) => (
                  <Select.Option key={name} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <br />

        <h3>Position (GPS & other)</h3>
        <div className="row">
          {/* Latitude */}
          <div className="col-6">
            <div className="input-box">
              <label>Latitude</label>
              <Input
                disabled
                value={position_in_latitude}
                placeholder="Latitude"
                onChange={(e) => set_position_in_latitude(e.target.value)}
              />
            </div>
          </div>
          {/* Longitude */}
          <div className="col-6">
            <div className="input-box">
              <label>Longitude</label>
              <Input
                disabled
                value={position_in_longitude}
                placeholder="Longitude"
                onChange={(e) => set_position_in_longitude(e.target.value)}
              />
            </div>
          </div>
        </div>
        <br />

        <h3>Speed</h3>
        <div className="row">
          {/* Speed or Gps */}
          <div className="col-6">
            <div className="input-box">
              <label>Speed through GPS (in knots)</label>
              <Input
                disabled
                value={speed}
                placeholder="Speed through GPS"
                onChange={(e) => set_speed(e.target.value)}
              />
            </div>
          </div>
          {/* on Ground */}
          <div className="col-6">
            <div className="input-box">
              <label>Speed through Water (in knots)</label>
              <Input
                disabled
                value={speed_on_ground}
                placeholder="Speed through Water"
                onChange={(e) => set_speed_on_ground(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          {/* distance Covered  */}
          <div className="col-6">
            <div className="input-box">
              <label>Distance Covered (In nautical miles)</label>
              <Input
                disabled
                value={distance_covered}
                placeholder="Distance Covered"
                onChange={(e) => set_distance_covered(e.target.value)}
              />
            </div>
          </div>

          <div className="col-6">
            <div className="input-box">
              <label>Distance to go (In nautical miles)</label>
              <Input
                disabled
                value={distance_to_go}
                placeholder="Distance To Go"
                onChange={(e) => set_Distance_To_Go(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Course/Heading (In degrees)</label>
              <Input
                disabled
                value={course_heading}
                placeholder="Course/Heading"
                onChange={(e) => set_course_heading(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>Hours Underway</label>
              <Input
                value={hours_Underway}
                placeholder="Hours Underway"
                onChange={(e) => set_Hours_Underway(e.target.value)}
              />
            </div>
          </div>
        </div>
        <br />
        <h3>Voyage Details</h3>
        <div className="row">
          {/* Loaded/ Ballast  */}
          <div className="col-6">
            <div className="input-box">
              <label>Loaded/ Ballast</label>
              <Input
                disabled
                value={loaded_ballast}
                placeholder="Loaded/ Ballast"
                onChange={(e) => set_loaded_ballast(e.target.value)}
              />
            </div>
          </div>
          {/* Draft */}
          <div className="col-6">
            <div className="input-box">
              <label>Draft (In meter)</label>
              <Input
                disabled
                value={draft}
                placeholder="Draft"
                onChange={(e) => set_draft(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          {/* Qty of cargo  */}
          <div className="col-6">
            <div className="input-box">
              <label>Quantity of Cargo</label>
              <Input
                disabled
                value={voyage_qty_of_cargo}
                placeholder="Quantity of Cargo"
                onChange={(e) => set_voyage_qty_of_cargo(e.target.value)}
              />
            </div>
          </div>
          {/* qty of bllast */}
          <div className="col-6">
            <div className="input-box">
              <label>Quantity of Ballast</label>
              <Input
                disabled
                value={qty_of_ballast}
                placeholder="Quantity of Ballast"
                onChange={(e) => set_qty_of_ballast(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="row">
          {/* Port From */}
          <div className="col-6">
            <div className="input-box">
              <label>Port From</label>
              <Input
                disabled
                value={port_from}
                placeholder="Port From"
                onChange={(e) => set_port_from(e.target.value)}
              />
            </div>
          </div>
          {/* Port To */}
          <div className="col-6">
            <div className="input-box">
              <label>Port To</label>
              <Input
                disabled
                value={port_to}
                placeholder="Port To"
                onChange={(e) => set_port_to(e.target.value)}
              />
            </div>
          </div>
        </div>

        <h3>Charterer Details</h3>
        <div className="row">
          {/* Instructed Speed? */}
          <div className="col-6">
            <div className="input-box">
              <label>Instructed Speed</label>
              <Input
                disabled
                value={instructed_speed}
                placeholder="Instructed Speed"
                onChange={(e) => set_instructed_speed(e.target.value)}
              />
            </div>
          </div>
        </div>
        <h3>Fuel ROB</h3>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>HSFO ROB</label>
              <Input
                disabled
                value={hsfo_consumption}
                placeholder="HSFO fuel Consumption"
                onChange={(e) => set_hsfo_consumption(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>VLSFO ROB</label>
              <Input
                disabled
                value={vlsfo_consumption}
                placeholder="VLSFO fuel Consumption"
                onChange={(e) => set_vlsfo_consumption(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>LO ROB</label>
              <Input
                disabled
                value={lo_consumption}
                placeholder="LO fuel Consumption"
                onChange={(e) => set_lo_consumption(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>FW ROB</label>
              <Input
                disabled
                value={fw_consumption}
                placeholder="VLSFO fw Consumption"
                onChange={(e) => set_fw_consumption(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>LSMGO ROB</label>
              <Input
                disabled
                value={lsmgo_consumption}
                placeholder="LSMGO fuel Consumption"
                onChange={(e) => set_lsmgo_consumption(e.target.value)}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="input-box">
              <label>OTHER ROB</label>
              <Input
                disabled
                value={other_consumption}
                placeholder="Other fuel Consumption"
                onChange={(e) => set_other_consumption(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <div className="input-box">
              <label>Deck Logbook Comments</label>
              <TextArea
                disabled
                rows={6}
                placeholder="Deck Logbook Comments"
                maxLength={1000}
                value={free_Text}
                onChange={(e) => set_Free_Text(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompanyViewDeckLog;
